import { Injectable } from '@angular/core';
import { Column } from '../classes/column';
import { clone } from '@kaiser-software/chassis-core/src/app/support/helpers/clone.function';
import { BehaviorSubject, ReplaySubject, Subject } from 'rxjs';
import { CompositeFilterDescriptor, SortDescriptor } from '@progress/kendo-data-query';
import { State } from '../interfaces/state';
import { StateChangeEvent, Type } from '../classes/state-change-event';

@Injectable()
export class DataTableStateService {

    /**
     * The current state snapshot.
     */
    public snapshot: State = {
        skip: 0,
        take: 25,
        columns: [],
        sort: [],
        group: [],
        filter: {
            logic: 'and',
            filters: [],
        },
    };

    /**
     * Observable which emits every time the state changes.
     */
    public state: Subject<State> = new BehaviorSubject(this.snapshot);

    /**
     * Observable which emits every time the state changes,
     * but skips initial value state change emits.
     */
    public changes: Subject<StateChangeEvent> = new ReplaySubject();

    public setColumns(columns: Array<Column>, initial = false): this {
        const state   = clone(this.snapshot);
        state.columns = clone(columns);
        this.snapshot = state;
        this.change('column', initial);
        return this;
    }

    public setSkip(skip: number, initial = false): this {
        const state   = clone(this.snapshot);
        state.skip    = skip;
        this.snapshot = state;
        this.change('skip', initial);
        return this;
    }

    public setTake(take: number, initial = false): this {
        const state   = clone(this.snapshot);
        state.take    = take;
        this.snapshot = state;
        this.change('take', initial);
        return this;
    }

    public setSort(sort: Array<SortDescriptor>, initial = false): this {
        const state   = clone(this.snapshot);
        state.sort    = clone(sort);
        this.snapshot = state;
        this.change('sort', initial);
        return this;
    }

    public setFilter(filter: CompositeFilterDescriptor, initial = false): this {
        const state   = clone(this.snapshot);
        state.filter  = clone(filter);
        this.snapshot = state;
        this.change('filter', initial);
        return this;
    }

    protected change(type: Type, initial = false): void {
        this.state.next(this.snapshot);

        if (!initial) {
            this.changes.next({
                type: type,
                state: this.snapshot,
            });
        }
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-datatable/src/services/data-table-state.service.ts